/** Üretim alan adı — canonical, OG, sitemap ile uyumlu */
export const SITE_URL = 'https://kombikurumsalservis.com';

export const SITE_NAME = 'Kombi Kurumsal Servis';

export const SITE_PHONE_DISPLAY = '0533 283 66 79';

export const SITE_PHONE_E164 = '+905332836679';

/** schema.org telephone (uluslararası tireli) */
export const SITE_PHONE_SCHEMA = '+90-533-283-6679';

/** Mutlak URL — sosyal önizleme görselleri için */
export const SITE_DEFAULT_OG_IMAGE = `${SITE_URL}/images/hero-boiler-blue-v2.jpg`;

export const SITE_DEFAULT_TITLE =
  'Kombi Kurumsal Servis | Kombi Tamiri, Bakım ve 7/24 Acil Servis — 0533 283 66 79';

export const SITE_DEFAULT_DESCRIPTION =
  'ECA, Demirdöküm, Bosch, Vaillant ve tüm marka kombiler için yerinde kombi tamiri, bakım ve montaj. Şu an açık servis hattı, hızlı randevu ve 7/24 acil kombi servisi. Hemen arayın: 0533 283 66 79.';
